module.exports = __webpack_public_path__ + "static/continue capital-9836c17ce3d841e8b320da79ba20ff14.png";